/* eslint-disable import/no-cycle */
// import { OffenceType } from "src/modules/offenceReport/types";
import { Color } from "ui/primitives";
import {
  ActionType,
  BannerTypes,
  ContentType,
  FeedComponents,
  LayoutTypes,
} from "../constants";
import { OffenceType } from "./offence";

export * from "./category";
export * from "./createOffenceData";
export * from "./feed";
export * from "./history";
export * from "./offence";
export * from "./offenceDetails";
export * from "./streaks";

export type UserType = {
  userName: string;
  displayName: string;
  dob?: string;
  profileImg: string;
  city?: string;
  state?: string;
  bio?: string;
  email?: string;
  isAdmin?: boolean;
  isBot?: boolean;
  isInfluencer?: boolean;
  userId: number;
  coverImg?: string;
  isFollowed?: boolean;
  maxStreakCount?: number;
  followerCount?: number;
};

export type LeaderBoardType = UserType & {
  maxStreakCount: number;
  fuelWon: number;
  rank: number;
};

export type optionType = {
  optionId: number;
  optionName: string;
  optionVotes: number;
  optionImageUrl: string;
};

export type quizOptionType = {
  optionId: string;
  optionName: string;
  optionVotes: number;
};

export type StreakType = {
  currStreak?: number;
  maxStreak?: number;
};

export type UserProfileDetails = {
  userInfo: UserType;
  interactions: {
    answerCount: number;
    commentCount: number;
    pollCount: number;
    postCount: number;
    questionCount: number;
    followersCount: number;
    followingCount: number;
  };
  vehicleData?: {
    brandIcon: string;
    brand: string;
    model: string;
    vehicleNo: string;
  };
  tags?: TagType[];
  banner: BannerType[];
  isBlocked?: boolean;
  streak?: StreakType;
};

export type FeedType = {
  componentType: FeedComponents;
  layout: LayoutTypes;
  feedData?: PostType | null;
  trendingData?: PostType[];
  bannerData?: BannerType | null;
  discoverData?: ComponentType | null;
  discoverComponentId?: string;
  themeBotData?: PostType[];
  multipleThemeBotData?: PostType[];
  influencersPost?: PostType[];
  interestData?: TagType[];
  followUsers?: UserType[];
  adsData?: PostType | null;
  pplPoll?: PostType | null;
  pplContent?: PostType[];
  offences?: OffenceType[];
  title?: string;
  banner?: BannerType | null;
  lot: number;
  page: number;
  seed: number;
  ignoreUuid?: string[];
  isRecommended?: boolean;
  carReviewsPosts?: PostType[];
  pollOfTheDay?: PostType[];
};

export type FilteredFeedType = {
  [key: string]: {
    feed: FeedType[];
    pageIndex: number;
    scrollPosition: number;
  };
};

export type DiscoverDataType = {
  cardId?: string;
  slugId?: string;
  uiType: DiscoverContentType;
  title: string;
  shortTitle: string;
  bgImg: string;
  authorImg?: string;
  authorName?: string;
  url?: string;
  publishedAt: string;
};

export type RedirectionType = {
  actionType: ActionType;
  webUrl?: string;
  screenId?: number;
  buttonLabel?: string;
};

export type PostType = {
  uuid: string;
  heading: string;
  body: string;
  bodyTrim?: string;
  likeCount: number;
  isBookmarked: boolean;
  isLiked: boolean;
  reactionType?: number;
  reactions?: { [key: number]: number };
  shareCount: number;
  commentCount: number;
  createdAt: string;
  author: UserType;
  parentPost?: PostType | null;
  media?: MediaType[];
  contentType: ContentType;
  lat?: number;
  lng?: number;
  reviewStatus: number;
  primaryTags: string[];
  secondaryTags: string[];
  userSelectedTags: string[];
  primarySecondaryMap: string[];
  isReviewed: boolean;
  reportCount: number;
  isActive?: boolean;
  options?: optionType[];
  isVoted?: number;
  totalVotes?: number;
  parentUuid?: string;
  modAckByUser?: boolean;
  shareText?: string;
  isPinned?: boolean;
  isRecommended?: boolean;
  isAdminPost?: boolean;
  highlightedLikesData: LikeType[];
  highlightedCommentsData: CommentType[];
  templateId?: number;
  userTaggingData?: UserType[];
  adsRedirection?: RedirectionType;
  discoverData?: DiscoverDataType;
  recommendationType?: string;
  viewCount?: number;
  visibilityDate?: string;
  streaks?: {
    streakScore: number;
    fuelReward: number;
    totalFuelReward: number;
    bgColor: string;
    color: keyof typeof Color;
  };
  isPollExpired?: boolean;
  pollExpiryTime?: string;
  rating?: number;
};

export type MediaType = {
  type: string;
  url: string;
  thumbnailUrl?: string;
};

export type TagType = {
  uuid: string;
  name: string;
  categoryId?: number;
};

export type FollowType = {
  users: UserType[];
  bots: UserType[];
};

export type CategoryTagType = {
  category: string;
  categoryImg: string;
  tags: TagType[];
};

export type CommentType = {
  comment: string;
  commentType?: boolean;
  contentUuid: string;
  createdAt: string;
  parentUuid?: string;
  userId: number;
  uuid: string;
  author: UserType;
  repliesCount: number;
  likesCount: number;
  isLiked: boolean;
  media: MediaType[];
  userTaggingData?: UserType[];
  isReported?: boolean;
};

export type LikeType = {
  uuid: string;
  contentUuid: string;
  userId: number;
  author: UserType;
  reactionType: number;
};

export type LikeListType = {
  data: LikeType[];
  count: number;
};

export type SearchSuggestions = {
  tags: TagType[];
  posts: PostType[];
  users: UserType[];
  next?: string | null;
};

export type SecondaryTagsType = {
  title: string;
  slug: string;
};

export type GuideLinePrimaryTags = {
  title: string;
  slug: string;
  secondaryTags: SecondaryTagsType[];
};

export type ChallengesList = {
  uuid: string;
  name: string;
  description: string;
  totalTask: number;
  completedTask: number;
  darkImage: string;
  coloredImage: string;
  isActive: number;
  completedPercent: number;
  rewardDate: string;
  rewardStatus: string;
};

export type TaskList = {
  uuid: number;
  name: string;
  description: string;
  completedImg: string;
  incompleteImg: string;
  darkBadge: string;
  coloredBadge: string;
  isActive: number;
  isCompleted: number;
  actionType: string;
  webUrl: string;
  screenId: string;
};
export type TaskListData = {
  data: TaskList[];
  completedPercentage: number;
};
export type Reward = {
  userId: number;
  status: string;
  heading: string;
  subHeading: string;
  isEligible: number;
  rewardType: number;
  expiryDate: string;
  rewardDate: string;
  giftData: any;
};

export type StoryBubble = {
  id: string;
  cardImg: string;
  title: string;
  screenId: number;
  webUrl: string;
};

export type BannerType = {
  id: number;
  type: BannerTypes;
  heading: string;
  bg: string;
  isActive: boolean;
  name: string;
  subHeading: string;
  button: {
    color: string;
    text: string;
    textColor: string;
    actionType: ActionType;
    webUrl?: string;
    screenId?: number;
  };
  activeChallenge?: string;
  activeChallengeUuid?: string;
};
export type HomeBannerType = {
  percentage?: number;
  taskCompleted?: number;
  totalTask?: number;
  banner: BannerType;
  activeChallenge?: string;
  activeChallengeUuid?: string;
};

export type BadgeType = {
  badgeName: string;
  uuid: string;
  completedImg: string;
  inProgressImg: string;
  isActive: boolean;
};

export type UsernameValidation = {
  uname: string;
  status: "success" | "fail" | "grey";
};

export type RecommendedPostType = {
  contentBasedPosts: PostType[];
  userBasedPosts: PostType[];
};

export type PostCategoryType = {
  id: number;
  categoryName: string;
  templates: PostTemplateType[];
};

export type PostTemplateType = {
  id: number;
  template: string;
};

export type FeedFilterType = {
  icon: string;
  label: string;
  value: number | string;
  order: number;
  selectedIcon: string;
  showTabsAnimation: boolean;
  brand: string;
};

export type ComponentType =
  | Video[]
  | Image[]
  | Tag[]
  | Insight[]
  | News[]
  | Short[]
  | Playlist[]
  | Blog[]
  | quizType[];

//Types
export enum RenderingType {
  VERTICAL_LIST = "vertical",
  HORIZONTAL_LIST = "horizontal",
  MOSAIC = "mosaic",
  COVER = "full_width",
  PLAYLIST_ITEM = "playlist_item",
}

export enum DiscoverContentType {
  SHORT = "shorts",
  NEWS = "news_feed",
  STORY = "story", // insights
  BLOG = "blogs",
  VIDEO = "videos",
  IMAGE = "photos",
  PLAYLIST = "playlist",
  TAG = "tags",
  QUIZ = "quiz",
}

export enum LibraryType {
  HEADER_VIDEO = "header_video",
  PLAYLIST_SYS = "playlist_sys",
  PLAYLIST_LIB = "playlist_lib",
  PLAYLIST = "playlist_preset",
  TOPIC = "topics",
  HASHTAG = "hashtags",
  INTEREST = "interests",
  EMPTY = "",
}

export interface Interest {
  icon: string;
  title: string;
  isSelected: boolean;
  id: string;
  bgImg: string;
}

export interface Tag {
  icon: string;
  title: string;
  isSelected: boolean;
  id: string;
  thumb: string;
  parentId: string;
  uiType?: string;
}

export interface Insight {
  id: string;
  title: string;
  thumb: string;
  url: string;
  isBookmark: boolean;
  isLiked: boolean;
  order: string;
  likeCount: number;
  parentId: number;
  uiType: string;
  shareText: string;
  searchCategory?: string;
}

export interface News {
  id: string;
  title: string;
  date: string;
  thumb: string;
  url: string;
  isBookmark: boolean;
  isLiked: boolean;
  author: {
    name: string;
    avatar: string;
  };
  shareText: string;
  parentId: string;
  order: string;
  uiType: string;
  searchCategory?: string;
}

export interface Short {
  id: string;
  title: string;
  date: string;
  thumb: string;
  url: string;
  isBookmark: boolean;
  isLiked: boolean;
  author: {
    name: string;
    avatar: string;
  };
  shareText: string;
  parentId: string | number;
  videoId: string | number;
  isYoutube: boolean;
  videoThumbnail: string;
  channelName: string;
  channelLogo: string;
  likeCount: number;
  viewCount: number;
  shareMsg: string;
  isChannelFollowed: boolean;
  uiType: string;
  order: string;
  searchCategory?: string;
}

export interface Video {
  id: string;
  title: string;
  date: string;
  thumb: string;
  url: string;
  isYoutube: boolean;
  isBookmark: boolean;
  isLiked: boolean;
  isChannelFollowed: boolean;
  author: {
    name: string;
    avatar: string;
  };
  shareText: string;
  viewCount: number;
  likeCount: number;
  duration: number;
  parentId: number;
  order: string;
  uiType: string;
  searchCategory?: string;
}

export interface Image {
  id: string;
  title: string;
  date: string;
  thumb: string;
  url: string;
  isBookmark: boolean;
  isLiked: boolean;
  likeCount: number;
  author: {
    name: string;
    avatar: string;
  };
  shareText: string;
  parentId: number;
  uiType: string;
  order: string;
  searchCategory?: string;
}

export interface Playlist {
  id: string;
  title: string;
  date: string;
  thumb: string;
  url: string;
  isYoutube: boolean;
  isBookmark: boolean;
  isLiked: boolean;
  isChannelFollowed: boolean;
  author: {
    name: string;
    avatar: string;
  };
  shareText: string;
  viewCount: number;
  likeCount: number;
  duration: number;
  parentId: number;
  videos: string[];
  order: string;
  uiType: string;
  searchCategory?: string;
}

export interface Blog {
  id: string;
  title: string;
  description: string;
  date: string;
  thumb: string;
  url: string;
  isBookmark: boolean;
  author: {
    name: string;
    avatar: string;
  };
  shareText: string;
  viewCount: number;
  order: string;
  parentId: string;
  uiType: string;
  searchCategory?: string;
}

export interface Section {
  id: string;
  order: number;
  upFrontCardsCount: number;
  title: string;
  uiType: RenderingType;
  contentType: DiscoverContentType;
  libraryType: LibraryType | null;
  items: ComponentType;
  seed?: string;
  attemptedQuestions?: number;
  userSummary?: UserSummaryType;
}

export interface View {
  id: string;
  title: string;
  order: number;
  sections: Section[];
}

export interface quizType {
  correctOptionId?: string;
  options: quizOptionType[];
  id: string;
  text: string;
  title: string;
  questionType?: string;
  selectedOptionId: string;
  description?: string;
  uiType: DiscoverContentType;
  backgroundImage: string;
  quizId?: string;
  isViewed?: boolean;
  timer?: number;
  expiryTime?: string;
}

export interface StreakExtraRewardType {
  show: boolean;
  showPopup: boolean;
  reward?: {
    title: string;
    subtitle: string;
    label: string;
    img: string;
    promo: string;
    redirection: {
      showCta: boolean;
      ctaTitle: string;
      screenId: number;
      webUrl: string;
    };
  };
}

export type QuizAnswerType = {
  correctOptionId: string;
  isCorrect: boolean;
  questionId: string;
  selectedOptionId: string;
};

export type UserSummaryType = {
  questions: quizType[];
  userSummary: {
    correctAnswers: number;
    percentile: number;
    remarks: string;
    shareLink: string;
    totalQuestions: number;
    shareText: string;
    subTitle: string;
  };
};

export type NotificationCenterDataType = {
  cta?: RedirectionType;
  notificationRedirection: RedirectionType;
  notificationImages: {
    userId: number;
    imageUrl: string;
    redirectionData: RedirectionType;
  }[];
  notificationText: {
    redirectionData: RedirectionType;
    text: string;
    image: string;
    colour: string;
  }[];
};
